export default {
  title: 'Henkilökohtaiset tiedot',
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    personal_info_updated_successfully: 'Tietosi tallennettiin onnistuneesti',
  },
};
